import type {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'
import {pullRequestsAppBuilder} from '../config/app-builder'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import type {CommitsRoutePayload} from './route-payload-types'
import {useRouteQueryKey} from '@github-ui/react-core/future/use-route-query-key'

export function buildPullRequestsCommitsRoute(appBuilder: DataRouterApplicationBuilder<string>) {
  return appBuilder.createQueryRouteConfig('pullRequestsCommitsRoute', {
    path: '/:owner/:repo/pull/:pr_number/commits',
    queries: [mainQuery<CommitsRoutePayload>()],
  })
}

export const pullRequestsCommitsRoute = buildPullRequestsCommitsRoute(pullRequestsAppBuilder)

/**
 * Reads and returns the full, generated query key for the mounted route.
 */
export function useCommitsRouteQueryKey() {
  return useRouteQueryKey(pullRequestsCommitsRoute, 'mainQuery')
}

/**
 * Generated and returns a partial query key for the unmounted route.
 *
 * If a route is not currently mounted, this can be used to get a partial query key without querydeps.
 * This is sufficient for invalidating or refetching queries.
 */
export function useCommitsRoutePartialQueryKey() {
  return pullRequestsCommitsRoute.queries.mainQuery.makeQueryKey()
}
